import { ComplexValue } from 'app/types-shared';
import { DefaultFilter, DefaultFilterMetadata } from 'app/area/shared/default-filters/types-store';
import { SavedReportDashboard } from '../common/types-store';
import { DashboardItem, DashboardItemValidation } from './types-store';

export const ACTION = {
  REQUEST_LANGUAGE_OPTIONS: 'DASHBOARD_ADMIN_FORM:REQUEST_LANGUAGE_OPTIONS',
  RECEIVE_LANGUAGE_OPTIONS: 'DASHBOARD_ADMIN_FORM:RECEIVE_LANGUAGE_OPTIONS',
  FAIL_LANGUAGE_OPTIONS: 'DASHBOARD_ADMIN_FORM:FAIL_LANGUAGE_OPTIONS',

  REQUEST_DASHBOARD: 'DASHBOARD_ADMIN_FORM:REQUEST_DASHBOARD',
  RECEIVE_DASHBOARD: 'DASHBOARD_ADMIN_FORM:RECEIVE_DASHBOARD',
  FAIL_DASHBOARD: 'DASHBOARD_ADMIN_FORM:FAIL_DASHBOARD',

  REQUEST_DELETE_DASHBOARD: 'DASHBOARD_ADMIN_FORM:REQUEST_DELETE_DASHBOARD',
  RECEIVE_DELETE_DASHBOARD: 'DASHBOARD_ADMIN_FORM:RECEIVE_DELETE_DASHBOARD',
  FAIL_DELETE_DASHBOARD: 'DASHBOARD_ADMIN_FORM:FAIL_DELETE_DASHBOARD',

  REQUEST_SAVE_DASHBOARD: 'DASHBOARD_ADMIN_FORM:REQUEST_SAVE_DASHBOARD',
  RECEIVE_SAVE_DASHBOARD: 'DASHBOARD_ADMIN_FORM:RECEIVE_SAVE_DASHBOARD',
  FAIL_SAVE_DASHBOARD: 'DASHBOARD_ADMIN_FORM:FAIL_SAVE_DASHBOARD',

  UPDATE_ITEM: 'DASHBOARD_ADMIN_FORM:UPDATE_ITEM',

  CHANGE_LANGUAGE: 'DASHBOARD_ADMIN_FORM:CHANGE_LANGUAGE',
  COPY_LANGUAGE_TO_ALL: 'DASHBOARD_ADMIN_FORM:COPY_LANGUAGE_TO_ALL',

  CLEAR_FORM: 'DASHBOARD_ADMIN_FORM:CLEAR_FORM',

  UPDATE_VALIDATION: 'DASHBOARD_ADMIN_FORM:UPDATE_VALIDATION'
};

export class RequestLanguageOptions {
  public type: string = ACTION.REQUEST_LANGUAGE_OPTIONS;
}

export class ReceiveLanguageOptions {
  public type: string = ACTION.RECEIVE_LANGUAGE_OPTIONS;
  constructor(public options: ComplexValue<number>[]) { }
}

export class FailLanguageOptions {
  public type: string = ACTION.FAIL_LANGUAGE_OPTIONS;
}

export class RequestDashboard {
  public type: string = ACTION.REQUEST_DASHBOARD;
  constructor(public id: number) { }
}

export class ReceiveDashboard {
  public type: string = ACTION.RECEIVE_DASHBOARD;
  constructor(
    public id: number,
    public item: DashboardItem,
    public savedReports: SavedReportDashboard[],
    public filters: DefaultFilter[],
    public filterMetadata: DefaultFilterMetadata[]
  ) { }
}

export class FailDashboard {
  public type: string = ACTION.FAIL_DASHBOARD;
  constructor(public id: number) { }
}

export class RequestDeleteDashboard {
  public type: string = ACTION.REQUEST_DELETE_DASHBOARD;
  constructor(public id: number) { }
}

export class ReceiveDeleteDashboard {
  public type: string = ACTION.RECEIVE_DELETE_DASHBOARD;
  constructor(public id: number) { }
}

export class FailDeleteDashboard {
  public type: string = ACTION.FAIL_DELETE_DASHBOARD;
  constructor(public id: number) { }
}

export class RequestSaveDashboard {
  public type: string = ACTION.REQUEST_SAVE_DASHBOARD;
  constructor(public id: number) { }
}

export class ReceiveSaveDashboard {
  public type: string = ACTION.RECEIVE_SAVE_DASHBOARD;
  constructor(public id: number, public newDashboardId: number) { }
}

export class FailSaveDashboard {
  public type: string = ACTION.FAIL_SAVE_DASHBOARD;
  constructor(public id: number) { }
}

export class ClearForm {
  public type: string = ACTION.CLEAR_FORM;
}

export class UpdateItem {
  public type: string = ACTION.UPDATE_ITEM;
  constructor(public item: Partial<DashboardItem>) { }
}

export class ChangeLanguage {
  public type: string = ACTION.CHANGE_LANGUAGE;
  constructor(public languageId: number, public description: string) { }
}

export class CopyLanguageToAll {
  public type: string = ACTION.COPY_LANGUAGE_TO_ALL;
  constructor(public languageId: number) { }
}

export class UpdateValidation {
  public type: string = ACTION.UPDATE_VALIDATION;
  constructor(public validation: DashboardItemValidation) { }
}
